<template>
  <div id="app">
    <el-row>
      <el-col :span="20">
    <el-steps :active="active" finish-status="success">
  <el-step title="Proposta Comercial"></el-step>
  <el-step title="Apresentação da Empresa"></el-step>
  <el-step title="Conteúdo da Proposta"></el-step>
  <el-step title="Visualizar Proposta Pronta"></el-step>
  <el-step title="Finalizar"></el-step>
  </el-steps>

      </el-col>
    </el-row>
    <el-row>
      <el-col :span="20">
        <el-button style="margin-top: 12px;" @click="anterior">Passo Anterior</el-button>
        <el-button style="margin-top: 12px;" @click="next">Próximo Passo</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
          <Passo0 v-if="active==0"></Passo0>
          <Passo1 v-else-if="active===1"></Passo1>
          <Passo2 v-else-if="active===2"></Passo2>
          <Passo3 v-else-if="active===3"></Passo3>
          <Passo4 v-else-if="active===4"></Passo4>
      </el-col>
    </el-row>

  </div>
</template>

<script>


import Passo0 from "@/components/teste/Passo0.vue";
import Passo1 from "@/components/teste/Passo1.vue";
import Passo2 from "@/components/teste/Passo2.vue";
import Passo3 from "@/components/teste/Passo3.vue";
import Passo4 from "@/components/teste/Passo4.vue";
import FuncoesUteis from "../../plugins/FuncoesUteis";

export default {
  components: {
 
    Passo0,
    Passo1,
    Passo2,
    Passo3,
    Passo4
  },
  
  
  data() {
    return {
      active: 0,
      permissao: {},
    };

  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
  },
  methods: {
      next() {
        if (this.active++ > 4) this.active = 0;
      },
      anterior() {
        if (this.active-- <= 0) this.active = 0;
      }      
    }
};
</script>

<style>
#editor1,
#editor2 {
  height: 350px;
}
</style>